import { cn } from "@newxsystems/shared";
import { getComponent } from "../../../../client";
import type { IStratosActionProps } from "./StratosAction.props";

const styles = {
  primary:
    "border-primary bg-primary text-primary-foreground hover:border-night-flight hover:bg-night-flight",
  secondary:
    "border-night-flight/25 bg-transparent text-foreground hover:border-night-flight hover:bg-night-flight hover:text-cloud-white",
  ghost:
    "border-transparent bg-transparent text-primary underline decoration-primary/40 underline-offset-4 hover:decoration-primary hover:underline-offset-8",
  destructive:
    "border-terracotta bg-terracotta text-primary-foreground hover:border-night-flight hover:bg-night-flight",
} as const;

export const StratosAction = ({ action, className }: IStratosActionProps) => {
  const Link = getComponent("Link");
  return (
    <Link
      aria-label={action.accessibilityLabel || undefined}
      className={cn(
        "inline-flex min-h-11 items-center justify-center rounded-full border px-6 py-3 font-stratos-body text-sm font-semibold leading-[1.4] transition-[background-color,border-color,color,text-underline-offset,transform] duration-200 ease-out hover:-translate-y-0.5 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring",
        styles[action.style || "primary"],
        className,
      )}
      href={action.href}
      rel={action.openInNewTab ? "noopener noreferrer" : undefined}
      target={action.openInNewTab ? "_blank" : undefined}
    >
      {action.label}
    </Link>
  );
};

StratosAction.displayName = "Content::StratosAction";
